<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div style="text-align: right">
        <a-button v-has="'ROLE_ADD'" type="link" @click="addRole">
          添加
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        ref="table.dataRef">
        <a-table-column
          align="center"
          data-index="name"
          title="角色"
          width="">
        </a-table-column>
        <a-table-column
          align="center"
          data-index="code"
          title="编码"
          width="">
        </a-table-column>
        <a-table-column
          align="center"
          data-index="description"
          title="描述"
          width="">
        </a-table-column>
        <a-table-column
          align="center"
          data-index="isActive"
          title="是否有效"
          width="">
          <template v-slot="text, record">
            <a-tag type="success" v-if="record.isActive==='YES'">是</a-tag>
            <a-tag type="danger" v-if="record.isActive==='NO'">否</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          title="操作"
          align="center">
          <template slot-scope="text, record">
            <a-button type="link" v-has="'ROLE_EDIT'" @click="editRole(record)">编辑
            </a-button>
<!--            <a-button type="link" v-has="'ROLE_DELETE'" @click="deleteRole(record.id)">删除-->
<!--            </a-button>-->
          </template>
        </a-table-column>
      </a-table>
    </div>
<!--    <a-modal-->
<!--      title="提示"-->
<!--      @close="closeForm"-->
<!--      v-model="form.visible">-->
<!--      <role-edit-->
<!--        v-if="form.visible"-->
<!--        :role-id="form.data.id"-->
<!--        :on-cancel-handler="closeForm"-->
<!--        :on-submit-handler="closeForm">-->
<!--      </role-edit>-->
<!--    </a-modal>-->
    <a-modal
      :title="form.data.id===null||form.data.id===''?'新增角色':'编辑角色'"
      v-model="form.visible"
      @cancel="onFormCancel" @ok="onFormSave">
      <role-edit
        v-if="form.visible"
        :role-id="form.data.id"
        ref="roleEditRef"
        :get-role-list="getRoleList">
      </role-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryRoles,
  _deleteRole,
} from '@/api/sysRoleApi';
import RoleEdit from './RoleEdit.vue';

async function getRoleList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascending' ? 'ASC' : 'DESC';
  }
  const result = await _queryRoles({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = result.data.roles;
}

function addRole() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editRole(record) {
  this.form.data.id = record.id;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getRoleList();
}

async function deleteRole(roleId) {
  this.$confirm('是否删除?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    const result = await _deleteRole(roleId);
    if (result.code === 1200) {
      this.$message({
        type: 'success',
        message: '删除成功!',
      });
      this.getRoleList();
    }
  });
}

function onFormSave() {
  // this.form.visible = false;
  this.$refs.roleEditRef.save();
  // this.getRoleList();
  // this.form.data = {};
  // this.getRoleList();
  this.closeForm();
}


function onFormCancel() {
  // this.form.visible = false;
  // this.getRoleList();
  // this.form.data = {};
  this.closeForm();
}

export default {
  name: 'RoleList',
  components: { RoleEdit },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getRoleList,
    deleteRole,
    editRole,
    addRole,
    closeForm,
    onFormSave,
    onFormCancel
  },
  created() {
    this.getRoleList();
  },
};
</script>

<style scoped>

</style>
